import {
  Page,
  PageHeader,
  PageHeaderTitle,
  PageBody,
  PageHeaderDescription,
  Link,
} from '@customerio/pluma-components/react';
import { PageTitle } from '@/components/page-title';
import { TasksTable } from '@/features/tasks';
import { useWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';
import { Navigate } from 'react-router-dom';
import { generatePath } from '@/services/router/generate-path';
import { useFeatureFlag, FeatureFlag } from '@/services/auth/feature-flags';

export default function Tasks() {
  const workspaceId = useWorkspaceIdFromCurrentUrl();
  const isWorkspaceHealthDashboardEnabled = useFeatureFlag(FeatureFlag.WorkspaceHealthDashboard);

  if (isWorkspaceHealthDashboardEnabled) {
    return (
      <Navigate
        to={generatePath(
          '/workspaces/:workspaceId/health',
          { workspaceId: workspaceId ?? 0 },
          { tab: 'data', scrollTo: 'tasks' },
        )}
        replace={true}
      />
    );
  }

  return (
    <>
      <PageTitle title="Tasks" />
      <Page w="full">
        <PageHeader>
          <PageHeaderTitle>Tasks</PageHeaderTitle>
          <PageHeaderDescription>
            Monitor background tasks, like segment creation and imports, across your workspace.{' '}
            <Link
              href="https://docs.customer.io/accounts-and-workspaces/workspace-tasks/"
              isExternal
              variant="secondary"
            >
              Learn more
            </Link>
          </PageHeaderDescription>
        </PageHeader>
        <PageBody>
          <TasksTable />
        </PageBody>
      </Page>
    </>
  );
}
